// extracted by mini-css-extract-plugin
module.exports = {"container":"_1F_j9","auto-size":"r2vT0","autoSize":"r2vT0","no-auto-size":"MSPw8","noAutoSize":"MSPw8"};